import React from "react"
import styled from "styled-components"
import { Chevron } from "@components/icons"
import colors from "@constants/colors"

const Container = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 20px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  display: flex;
  width: 72px;
  height: 72px;
  margin: 0 auto;
  box-shadow: 0 4px 20px 0 rgb(0 0 0 / 10%);
  border: 0.25rem solid ${colors.white};
  border-radius: 50%;
  background-color: ${colors.white};
`

const IconWrapper = styled.div`
  flex-direction: row;
  align-items: center;
  display: flex;
  transform: rotate(270deg);
  width: 64px;
  height: 64px;
`

interface BackToTopProps {}

const BackToTop: React.FC<BackToTopProps> = () => {
  return (
    <Container
      onClick={(e) => {
        window.scrollTo({ top: 0, behavior: "smooth" })
      }}
    >
      <IconWrapper>
        <Chevron strokeColor={colors.black} />
      </IconWrapper>
    </Container>
  )
}

export default BackToTop
